<template>
  <div class="detail-program">
    <img class="title" src="../../../static/images/insurance_case_title@2x.png">
    <div class="list">
      <div class="item" v-for="(item, index) in program" :key="index" @click="$router.push(item.route)">
        <img :src="item.poster">
        <div class="item-name">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    program: {
      type: Array,
      default: []
    },
  },
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
.detail-program {
  background-color: #FAFAFA;
  font-size: 100px;
}
.title {
  font-size: 1em;
  width: 1.12em;
  margin: auto;
  padding: .2em 0 .6em;
  display: block;
}
.list {
  font-size: 1em;
  width: 12em;
  display: flex;
  margin: auto;
  padding-bottom: .9em;
}
.item {
  text-align: center;
  font-size: 1em;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(51,51,51,1);
  cursor: pointer;
}
.item img {
  font-size: 1em;
  width: 3.3em;
  height: 2.5em;
  display: block;
}
.item-name {
  font-size: .16em;
}
@media (max-width: 1199px) and (min-width: 992px){
  .detail-program {
    font-size: calc(100px * .8);
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .detail-program {
    font-size: calc(100px * .6);
  }
}
@media screen and (max-width: 767px){
  .detail-program {
    font-size: calc(100px * .5);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/solution/detailProgram.vue